<form *ngIf="displayAntenneSelector"
	role="form" class="form-horizontal">
	<div class="form-group row row-centered">
		<antenne-selector
			[id]="'eantenne'"
			[mandatory]="true"
			[labelClass]="'col-md-3'"
			[fieldClass]="'col-md-9'"
			[wildcardOptionLabel]="null"
			[resetCommands]="antenneResetCommands$"
			(selectedAntenneChange)="antenneId$.next($event === null ? null : $event.id)"
			>
		</antenne-selector>
	</div>

	<!--  
	<div class="form-group row error-message" *ngIf="errorMessage">
		{{ errorMessage }}
	</div>
	-->
</form>
<h1 mat-dialog-title>Votre p&eacute;rim&egrave;tre de Charg&eacute; d'Acc&egrave;s et de Conduite</h1>
<div mat-dialog-content>
	<div *ngif="loading">Chargement en cours...</div>
	<perimetre [antennes]="perimetreAntennesCAC"></perimetre>
</div>
<h1 mat-dialog-title style="margin-top: 5px">Votre p&eacute;rim&egrave;tre de Charg&eacute; de Conduite</h1>
<div mat-dialog-content>
	<div *ngif="loading">Chargement en cours...</div>
	<perimetre [antennes]="perimetreAntennesCC"></perimetre>
</div>
<div mat-dialog-actions>
	<button class="btn" mat-button [mat-dialog-close]="false">Fermer</button>
</div>
